import clsx from 'clsx';
import React, { forwardRef } from 'react';
import Icon from './Icon';

const Input = forwardRef(
  (
    {
      label,
      wrapperClassName,
      icon,
      iconOnClick,
      quantity,
      errorMessage,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={clsx(
          'input__wrapper',
          errorMessage && 'input__wrapper--error',
          wrapperClassName
        )}
      >
        {label && (
          <>
            {quantity !== undefined && (
              <label
                htmlFor={props.id}
                className="input__label input__label--quantity"
              >
                ({quantity})
              </label>
            )}
            <label htmlFor={props.id} className="input__label">
              {label}
              {props.required && '*'}
            </label>
          </>
        )}

        {/* ✅ Wrap input and icon in a relative container */}
        <div className="input__field-wrapper">
          <input
            className={clsx(
              'input',
              icon && 'input--with-icon',
              errorMessage && 'input--error'
            )}
            {...props}
            ref={ref}
          />
          {icon &&
            (iconOnClick ? (
              <button
                type="button"
                className="input__icon-wrapper input__icon-wrapper--button"
                onClick={iconOnClick}
              >
                <Icon name={icon} size={24} className="input__icon" />
              </button>
            ) : (
              <div className="input__icon-wrapper input__icon-wrapper--not-button">
                <Icon name={icon} size={24} className="input__icon" />
              </div>
            ))}
        </div>
        {errorMessage && (
          <span className="input__error-message">{errorMessage}</span>
        )}
      </div>
    );
  }
);

export default Input;
